import { format } from 'date-fns';
import { dateFnsLocale } from 'shared/helpers/timeHelper';

// Data e duração dos relatórios no idioma da interface. O `formatTime` do
// @chatwoot/utils escreve "Sec/Min/Hr/Day" fixo em inglês e o `format` do date-fns
// sem `locale` escreve "Oct".

// `pt_BR` -> `pt-BR`: o `Intl` recusa o underscore.
const intlLocale = locale => String(locale || 'en').replace('_', '-');

export const formatReportDate = (date, pattern, locale) =>
  format(date, pattern, { locale: dateFnsLocale(locale) });

// Data curta pelo `Intl`: pt-BR sai "24 de out. de 2026" e en "Oct 24, 2026".
export const formatReportDay = (date, locale) =>
  new Intl.DateTimeFormat(intlLocale(locale), { dateStyle: 'medium' }).format(
    date
  );

const unitLabel = (value, unit, locale) =>
  new Intl.NumberFormat(intlLocale(locale), {
    style: 'unit',
    unit,
    unitDisplay: 'short',
  }).format(value);

// Mesmos cortes do `formatTime` do @chatwoot/utils: "2 min 5 s", "1 h 3 min", "2 d 4 h".
const LARGE_UNITS = [
  { seconds: 86400, unit: 'day', next: 'hour', nextSeconds: 3600 },
  { seconds: 3600, unit: 'hour', next: 'minute', nextSeconds: 60 },
  { seconds: 60, unit: 'minute', next: 'second', nextSeconds: 1 },
];

export const formatReportDuration = (timeInSeconds, locale) => {
  const part = LARGE_UNITS.find(({ seconds }) => timeInSeconds >= seconds);
  if (!part) return unitLabel(Math.floor(timeInSeconds), 'second', locale);

  const main = Math.floor(timeInSeconds / part.seconds);
  const rest = Math.floor((timeInSeconds % part.seconds) / part.nextSeconds);
  const mainLabel = unitLabel(main, part.unit, locale);
  return rest > 0
    ? `${mainLabel} ${unitLabel(rest, part.next, locale)}`
    : mainLabel;
};
